import { render, staticRenderFns } from "./ABALogo.vue?vue&type=template&id=25926b92&"
import script from "./ABALogo.vue?vue&type=script&lang=js&"
export * from "./ABALogo.vue?vue&type=script&lang=js&"
import style0 from "./ABALogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports